import { useState } from "react";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { friendlyError, sendEmail } from "../cardData";
import { mjtiContent } from "../mjtiContent";
import PasswordInput from "./PasswordInput";

// Real signup flow for the MJTI cohort. Bypasses the invite-only gate
// (this page is the gate for these users — they got here via Johni).
// Auth state change in App.js auto-routes to the tracker on success.
export default function MjtiSignupForm() {
  const c = mjtiContent.signupForm;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!name.trim() || !email.trim() || !password.trim()) {
      setErr("All fields are required.");
      return;
    }
    if (password.length < 6) {
      setErr("Password must be at least 6 characters.");
      return;
    }
    setBusy(true);
    try {
      const cred = await createUserWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );
      await updateProfile(cred.user, { displayName: name.trim() });
      await setDoc(doc(db, "users", cred.user.uid), {
        name: name.trim(),
        email: email.trim().toLowerCase(),
        friends: [],
        createdAt: new Date().toISOString(),
        invitesRemaining: 5,
        signupSource: "mjti",
      });
      sendEmail(
        "support@mahjspace.com",
        "New MahjSpace MJTI Signup",
        `<p><strong>${name.trim()}</strong> (${email.trim()}) signed up via the MJTI early-access page.</p>`
      );
      // Auth listener in App.js will flip page to "app" automatically.
    } catch (e2) {
      setErr(friendlyError(e2));
      setBusy(false);
    }
  };

  return (
    <form className="mjti-signup__form" onSubmit={onSubmit}>
      <div className="mjti-field">
        <label className="mjti-field__label" htmlFor="mjti-name">{c.nameLabel}</label>
        <input
          id="mjti-name"
          className="mjti-field__input"
          type="text"
          placeholder={c.namePlaceholder}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="given-name"
          required
        />
      </div>

      <div className="mjti-field">
        <label className="mjti-field__label" htmlFor="mjti-email">{c.emailLabel}</label>
        <input
          id="mjti-email"
          className="mjti-field__input"
          type="email"
          placeholder={c.emailPlaceholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
      </div>

      <PasswordInput
        id="mjti-password"
        label={c.passwordLabel}
        placeholder={c.passwordPlaceholder}
        value={password}
        onChange={setPassword}
        required
      />

      {err && <div className="mjti-signup__error">{err}</div>}

      <button type="submit" className="mjti-btn-primary" disabled={busy}>
        {busy ? "Creating your account…" : c.submit}
      </button>

      <p className="mjti-signup__legal">
        By signing up you agree to the{" "}
        <a href="?page=terms">Terms</a> and{" "}
        <a href="?page=privacy">Privacy Policy</a>.
      </p>
    </form>
  );
}
